export default __webpack_public_path__ + "static/media/extraBtnCheck.8849b10d.svg";